"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loading = exports.defaultState = void 0;
var actions = require("./actionTypes");
var requestStart_1 = require("./requestStart");
var requestFinish_1 = require("./requestFinish");
exports.defaultState = {
    active: false,
    activeRequests: [],
    total: 0,
    progress: 0
};
exports.loading = function (state, action) {
    if (state === void 0) { state = exports.defaultState; }
    switch (action.type) {
        case actions.LOADING:
            return requestStart_1.requestStart(state, action.request);
        case actions.LOAD_SUCCESS:
        case actions.LOAD_ERROR:
            return requestFinish_1.requestFinish(state, action.request);
        default:
            return state;
    }
};
